module.exports = __webpack_public_path__ + "static/fonts/notokr-medium.81bd542.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/artistry/makeover/font/notokr-medium.woff
// module id = E3L3
// module chunks = 0